module.exports = __webpack_public_path__ + "static/media/image70.0dbae69d.png";